<template>
  <RF-Dialog
  :cpntStatus='statusGeral'
  :cpntLargura='"695px"'
  :cpntTitulo='"Etiquetas"'

  :cpntOnFecharDialog='produtoEtiquetaFechar'>
  <template slot="titulo">
    <RF-Button style="margin-left: 5px;" v-if="Object.keys(buttonConfig).length >= 1"
      :cpntId='buttonConfig.id'
      :cpntStatus='buttonConfig.status' 
      :cpntTipo='buttonConfig.tipo' 
      :cpntIcone='buttonConfig.icone' 
      :cpntTexto='buttonConfig.texto' 
      :cpntClass='buttonConfig.class' 
      :cpntExplica='buttonConfig.explica' 

      @onClickButton='buttonConfig.onClick'
    ></RF-Button>
  </template>

  <template slot="conteudo">
    <RF-Dialog v-if="Object.keys(buttonConfig).length >= 1 && buttonConfig.mostrarConfig === true"
      :cpntStatus='""'
      :cpntLargura='"695px"'
      :cpntTitulo='buttonConfig.texto'

      :cpntOnFecharDialog='buttonConfig.onClick'>
      <template slot="conteudo">
        <RF-Produto-Etiqueta-Config
        :cpntConfig="config"
        :cpntAtualizaConfiguracoes="produtoEtiquetaAtualizarConfiguracoes"></RF-Produto-Etiqueta-Config>
      </template>
    </RF-Dialog>

    <div class="pro-eti">
      <div class="pro-eti-adicionar">
        <div class="titulo">
          <i aria-hidden="true" class="fa fa-angle-double-right"></i>
          <span>Adicionar produto</span>
        </div>
        <div class="formulario">
          <table>
            <tr v-if="[ '', null, undefined ].indexOf(formulario.field) === -1 && Object.keys(formulario.field).length >= 1">
              <td>
                <RF-Componente v-if="[ '', null, undefined ].indexOf(formulario.field.busca) === -1" class="rf-field-busca"
                  :data-time='time'
                  :cpntTamanho='formulario.field.busca.tamanho'
                  :cpntModelo='formulario.field.busca.tipo'
                  :cpntType='formulario.field.busca.type'
                  :cpntStatus='formulario.field.busca.status'
                  :cpntId='formulario.field.busca.id'
                  :cpntClassDivField='formulario.field.busca.classDivField'
                  :cpntNome='formulario.field.busca.nome'
                  :cpntValue='formulario.field.busca.value'
                  :cpntValueRef='formulario.field.busca.valueRef'
                  :cpntOptions='formulario.field.busca.options'
                  :cpntKeyValue='formulario.field.busca.keyValue'
                  :cpntKeyMostra='formulario.field.busca.keyMostra'
                  :cpntAutoComplete='formulario.field.busca.autocomplete'
                  :cpntDisabled='formulario.field.busca.disabled'
                  :cpntMostrar='formulario.field.busca.mostrar'
                  :cpntMensagem='formulario.field.busca.mensagem'
                  :cpntSelecioneNome='formulario.field.busca.selecioneNome'
                  :cpntSelecioneValue='formulario.field.busca.selecioneValue'
                  :cpntMensagemTipo='formulario.field.busca.mensagemTipo'
                  :cpntAdicinarOption='formulario.field.busca.adicinarOption'
                  :cpntMultiple='formulario.field.busca.multiple'
                  :cpntAllRegistro='formulario.field.busca.allRegistro'
                  :cpntExplica='formulario.field.busca.explica'
                  :cpntConfig='formulario.field.busca.config'
                  :cpntTabIndex='formulario.field.busca.tabIndex'
                  :cpntMaxLength='formulario.field.busca.maxLength'
                  :cpntOptionInicialNome='formulario.field.busca.optionInicialNome'
                  :cpntOptionInicialValue='formulario.field.busca.optionInicialValue'
                  :cpntRouter='formulario.field.busca.router'
                  :cpntMethod='formulario.field.busca.method'
                  :cpntField='formulario.field.busca.field'
                  :cpntWhere='formulario.field.busca.where'

                  :cpntOnChange='formulario.field.busca.onChange'
                  :cpntOnBlur='formulario.field.busca.onBlur'
                  :ref='formulario.field.busca.id'
                ></RF-Componente>
              </td>
              <td>
                <RF-Componente  v-if="[ '', null, undefined ].indexOf(formulario.field.qtde) === -1" class="rf-field-qtde"
                  :data-time='time'
                  :cpntTamanho='formulario.field.qtde.tamanho'
                  :cpntModelo='formulario.field.qtde.tipo'
                  :cpntType='formulario.field.qtde.type'
                  :cpntStatus='formulario.field.qtde.status'
                  :cpntId='formulario.field.qtde.id'
                  :cpntClassDivField='formulario.field.qtde.classDivField'
                  :cpntNome='formulario.field.qtde.nome'
                  :cpntValue='formulario.field.qtde.value'
                  :cpntValueRef='formulario.field.qtde.valueRef'
                  :cpntOptions='formulario.field.qtde.options'
                  :cpntKeyValue='formulario.field.qtde.keyValue'
                  :cpntKeyMostra='formulario.field.qtde.keyMostra'
                  :cpntAutoComplete='formulario.field.qtde.autocomplete'
                  :cpntDisabled='formulario.field.qtde.disabled'
                  :cpntMostrar='formulario.field.qtde.mostrar'
                  :cpntMensagem='formulario.field.qtde.mensagem'
                  :cpntSelecioneNome='formulario.field.qtde.selecioneNome'
                  :cpntSelecioneValue='formulario.field.qtde.selecioneValue'
                  :cpntMensagemTipo='formulario.field.qtde.mensagemTipo'
                  :cpntAdicinarOption='formulario.field.qtde.adicinarOption'
                  :cpntMultiple='formulario.field.qtde.multiple'
                  :cpntAllRegistro='formulario.field.qtde.allRegistro'
                  :cpntExplica='formulario.field.qtde.explica'
                  :cpntConfig='formulario.field.qtde.config'
                  :cpntTabIndex='formulario.field.qtde.tabIndex'
                  :cpntMaxLength='formulario.field.qtde.maxLength'
                  :cpntOptionInicialNome='formulario.field.qtde.optionInicialNome'
                  :cpntOptionInicialValue='formulario.field.qtde.optionInicialValue'

                  :cpntOnChange='formulario.field.qtde.onChange'
                  :cpntOnBlur='formulario.field.qtde.onBlur'
                  :cpntOnKeyPressEnter='formulario.field.qtde.onKeyPressEnter'
                  :ref='formulario.field.qtde.id'
                ></RF-Componente>
              </td>
            </tr>
            <tr v-if="[ '', null, undefined ].indexOf(formulario.buttons) === -1 && Object.keys(formulario.buttons).length >= 1">
              <td colspan="2" class="botoes">
                <template v-for="botao in formulario.buttons">
                  <RF-Button style="margin: 5px;" :key='botao.id'
                    :cpntId='botao.id'
                    :cpntStatus='botao.status' 
                    :cpntTipo='botao.tipo' 
                    :cpntIcone='botao.icone' 
                    :cpntTexto='botao.texto' 
                    :cpntClass='botao.class' 
                    :cpntExplica='botao.explica' 

                    @onClickButton='botao.onClick'
                  ></RF-Button>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>

      <div class="pro-eti-lista">
        <div class="titulo">
          <i aria-hidden="true" class="fa fa-angle-double-right"></i>
          <span>Etiquetas</span>

          <template v-if="(Object.keys(buttonGerar).length >= 1) && (Object.keys(tabela).length >= 1 && tabela.linha.length >= 1)">
            <RF-Button style="margin: 5px;"
              :cpntId='buttonGerar.id'
              :cpntStatus='buttonGerar.status' 
              :cpntTipo='buttonGerar.tipo' 
              :cpntIcone='buttonGerar.icone' 
              :cpntTexto='buttonGerar.texto' 
              :cpntClass='buttonGerar.class' 
              :cpntExplica='buttonGerar.explica' 

              @onClickButton='buttonGerar.onClick'
            ></RF-Button>
            
            <!-- VERIFICA SE DEVE ABRIR A IMPESSAO DAS ETIQUETAS -->
            <RF-Produto-Etiqueta-Impressao v-if="buttonGerar.imprimir === true"
            :cpntEtiquetas="etiquetas"
            :cpntConfig="config"
            :cpntFecharFormulario="buttonGerar.onClick"
            ></RF-Produto-Etiqueta-Impressao>
          </template>
        </div>

        <!-- SETA A TABELA DE REGISTROS -->
        <RF-Tabela v-if="Object.keys(tabela).length >= 1"
          :data-time='time'
          :cpntTime='time'
          :cpntId='tabela.id'
          :cpntStatus='tabela.status'
          :cpntButtonImprimir='tabela.acoes.btImprimir'
          :cpntButtonAtualizar='tabela.acoes.btAtualizar'
          :cpntFraseTop='tabela.fraseTop'
          :cpntInfoTabela='tabela.infoTabela'
          :cpntColuna='tabela.coluna'
          :cpntLinha='tabela.linha'
          :cpntCountAll='tabela.countAll'
          :cpntColspan='tabela.colspan'
          :cpntButtonsAcoes='tabela.acoes.buttons'
          :cpntMper='tabela.mper'
          :cpntPagina='tabela.pagina'
          :cpntCheckboxEditar='tabela.checkboxEditar'
          :cpntFieldsEditar='tabela.acoes.fields'

          :cpntOnCheckboxAtualiza='produtoEtiquetaOnCheckboxAtualiza'
          :ref='tabela.id'
        ></RF-Tabela>
      </div>
    </div>
  </template>
  </RF-Dialog>
</template>

<style socped>
  .pro-eti > div > .titulo {
    margin-bottom: 3px;
  }
    .pro-eti > div > .titulo > svg {
      margin-right: 5px;
    }
  .pro-eti > .pro-eti-adicionar > .formulario {
    padding: 20px 10px 5px 10px;
    background: #e9e9e9;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
    .pro-eti > .pro-eti-adicionar > .formulario > table {
      width: 100%;
    }
      .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td {
        padding: 5px 0px;
      }
      .pro-eti > .pro-eti-adicionar > .formulario > table > tr > .botoes {
        text-align: center;
      }

  .pro-eti > .pro-eti-lista {
    margin-top: 20px;
  }
</style>

<style>
  .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td > .rf-field-qtde > div > input {
    text-align: center;
  }
  .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td > div > div > input {
    border: 1px solid #ccc !important;
    border-radius: 5px;
  }
  .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td > div > div > label {
    top: -18px !important;
  }
  .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td > div > div {
    position: relative;
  }
  .pro-eti > .pro-eti-adicionar > .formulario > table > tr > td > div > div > ul {
    /* position: fixed !important; */
  }


  .pro-eti > div > table > tbody > tr > td.tab-produto-etiqueta-tab--td-id {
    width: 75px;
  }
  .pro-eti > div > table > tbody > tr > td.tab-produto-etiqueta-tab--td-nome,
  .pro-eti > div > table > tbody > tr > td.tab-produto-etiqueta-tab--td-nome > div {
    text-align: left;
  }
</style>

<script>
  export default {
    props: {
      cpntIds: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Produto-Etiqueta-Config': () => import('./RF-Produto-Etiqueta-Config.vue'),
      'RF-Produto-Etiqueta-Impressao': () => import('./RF-Produto-Etiqueta-Impressao.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        config: '',
        formulario: {},
        checkbox: [],
        tabela: {},
        buttonConfig: {},
        etiquetas: {},
        buttonGerar: {}
      }
    },
    mounted: function () {
      this.produtoEtiquetaIniciar()
    },
    methods: {
      produtoEtiquetaIniciar: function () {
        var self = this

        // SETA O STAUS DA TELA
        self.produtoEtiquetaSetarStatusGeral('carregando')

        // SETA O BOTÃO PARA CANCELAR
        self.buttonConfig = {
          status: '',
          id: self.formulario.id + '-bt-config',
          tipo: 'texto',
          texto: 'Configurações etiqueta',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          mostrarConfig: false,
          onClick: function () {
            // VERIFICA SE DEVE MOSTRAR OU NÃO A CONFIGURAÇÃO
            self.buttonConfig.mostrarConfig = !self.buttonConfig.mostrarConfig

            // // VERIFICA SE DEVE MOSTRAR OU OCULTAR AS CONFIGURAÇÕES
            // self.buttonConfig.texto = self.buttonConfig.mostrarConfig ? 'Ocultar' : 'Mostrar'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        }

        // SETA O BOTÃO PARA CANCELAR
        self.buttonGerar = {
          status: '',
          id: self.formulario.id + '-bt-config',
          tipo: 'texto',
          texto: 'Gerar',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          imprimir: false,
          onClick: self.produtoEtiquetaBuscarQtdeEstoqueGerar
        }

        // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
        const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK

        // EXECUTA A FUNÇÃO DE CALLBACKS
        FUN_TRATAR_RETONOS_E_CALLBACK(self, {
          produtoEtiquetaConfiguracoes: [ ],
          produtoEtiquetaCamposIniciar: [ ],
          produtoEtiquetaTabelaIniciar: [ ],
          produtoEtiquetaAdicionarItens: [ 'produtoEtiquetaConfiguracoes', 'produtoEtiquetaCamposIniciar', 'produtoEtiquetaTabelaIniciar' ],
          produtoEtiquetaFinalizarCarregamento: [ 'produtoEtiquetaAdicionarItens' ]
        },
        {
          produtoEtiquetaConfiguracoes: function (chave, callback, self) { self.produtoEtiquetaConfiguracoes(self, function () { callback(chave) } ) },
          produtoEtiquetaCamposIniciar: function (chave, callback, self) { self.produtoEtiquetaCamposIniciar(self, function () { callback(chave) } ) },
          produtoEtiquetaTabelaIniciar: function (chave, callback, self) { self.produtoEtiquetaTabelaIniciar(self, function () { callback(chave) } ) },
          produtoEtiquetaAdicionarItens: function (chave, callback, self) { self.produtoEtiquetaAdicionarItens(() => { callback(chave) }) },
          produtoEtiquetaFinalizarCarregamento: function (chave, callback, self) { self.produtoEtiquetaFinalizarCarregamento(self, function () { callback(chave) } ) },
        })
      },
      produtoEtiquetaFechar: function () {
        // CHAMA A FUNÇÃO PARA FECHAR A TELA
        if (this.cpntFecharFormulario !== null) {
          this.cpntFecharFormulario()
        }
      },
      produtoEtiquetaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      produtoEtiquetaAtualizarConfiguracoes: function (valores) {
        // SETA OS VALORES RECEBIDOS
        this.config = valores

        // VERIFICA SE DEVE MOSTRAR OU NÃO A CONFIGURAÇÃO
        this.buttonConfig.mostrarConfig = false

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      produtoEtiquetaConfiguracoes: function (self, callback) {
        // SALVA OS DADOS
        self.$store.state.GET_VALUE_LOCAL_STORAGE('PRO-CONFIG-ETIQ', function (valores) {
          if ([ '', null, undefined ].indexOf(valores) === -1 && [ '', null, undefined ].indexOf(valores.fields) === -1) {
            // SETA OS DADOS RECEBIDOS
            self.produtoEtiquetaAtualizarConfiguracoes(valores)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
  
            // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
            if (callback !== null) {
              callback()
            }
          } else {
            // INICIA A QUERY QUE SERÁ FEITA
            var queryGet = 'cb'
            
            // FAZ A BUSCA DOS DADOS NA API
            self.$store.state.comunicaAPI('/produto/config/get/', 'GET', queryGet, function (apiSuccess) {
              // SETA OS VALORES INICIAIS
              var valorInicial = { cfg_tam_logo: 200, cfg_rotacao_logo: 90, fields: [] }
    
              // SETA O VALOR INICIAL
              valorInicial.fields = [ '8007', '1036', '2239', '2701' ].indexOf(self.$store.state.token.clu) !== -1 ? [ 'logo', 'pro_nome', 'pro_codigo', 'pro_qtde_est', 'pro_codigo_barras' ] : [ 'pro_nome', 'pro_valor', 'pro_codigo_barras' ]
    
              // SETA OS DADOS RECEBIDOS
              self.produtoEtiquetaAtualizarConfiguracoes(Object.assign(valorInicial, apiSuccess.data[0]))
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
    
              // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
              if (callback !== null) {
                callback()
              }
            }, self.produtoEtiquetaSetarStatusGeral)
          }
        }, process.env.VUE_APP_CRI_KEY)
      },
      produtoEtiquetaCamposIniciar: function (self, callback) {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'produto-etiqueta-form-',
          field: {},
          buttons: {},
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // BUSCA DO PRODUTO
        self.formulario.field.busca = {
          tipo: 'auto-complite',
          id: self.formulario.id + '-busca',
          tamanho: 1,
          nome: 'Produto (DIGITE e SELECIONE)',
          router: '/produto/get',
          method: 'POST',
          field: { id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, valor_ven_novo: { a: 'valor_ven' }, cod_barra: null, status: null },
          where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'produto', o: 's.ft', v: '' } ] },
          keyMostra: [ 'nome', ' - ', 'id_cat_nome', ' - ', 'id_mar_nome', ' - ', 'codigo' ],
          value: '',
          valueRef: '',
          onChange: self.produtoEtiquetaOnChangeValue
        }

        // SETA A QUANTIDADE DE ETIQUETAS
        self.formulario.field.qtde = {
          id: self.formulario.id + '-qtde',
          tipo: 'input',
          tamanho: 3,
          nome: 'Quantidade',
          value: '1',
          onChange: self.produtoEtiquetaOnChangeValue,
          onKeyPressEnter: self.produtoEtiquetaOnKeyPressEnter
        }

        // SETA O BOTÃO PARA ADICONAR
        self.formulario.buttons.adicionar = {
          status: '',
          id: self.formulario.id + '-bt-adicionar',
          tipo: 'texto',
          texto: 'Adicionar',
          class: [ 'btn', 'btn-primary' ],
          onClick: self.produtoEtiquetaAdicionar
        }

        // SETA O BOTÃO PARA CANCELAR
        self.formulario.buttons.limpar = {
          status: '',
          id: self.formulario.id + '-bt-limpar',
          tipo: 'texto',
          texto: 'Limpar',
          class: [ 'btn', 'btn-default', 'btn-sm' ],
          onClick: self.produtoEtiquetaLimpar
        }

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if ([ '', null, undefined ].indexOf(callback) === -1) {
          callback()
        }
      },
      produtoEtiquetaTabelaIniciar: function (self, callback) {
        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.tabela = {
          status: 'carregando',
          id: 'produto-etiqueta-tab',
          montarTabelaCompleta: false,
          linha: [],
          acoes: {
            buttons: [
              { tipo: 'excluir', class: 'btn btn-danger btn-sm', onClick: self.produtoEtiquetaRemoverProduto }
            ]
          },
          ids: []
        }

        // SETA AS COLUNAS DA TABELA
        self.tabela.coluna = [
          { mPer: 3, tipo: 'RF-Checkbox', chave: 'index' },
          { mPer: 2, chave: 'codigo', nome: 'Cod.' },
          { mPer: 2, chave: 'nome', nome: 'Nome', tipo: 'link-produto', converte: { id: 'id', nome: 'nome', status: 'status' }, mostrarButton: true },
          { mPer: 2, chave: 'qtde', nome: 'Quantidade' },
        ]

        // FAZ A MONTAGEM DAS INFORMAÇÕES PARA TABELA
        self.$store.state.FUN_TABELA_CRIAR_DADOS(self.tabela, function (tabelaSuccess) {
          // SETA OS DADOS RECEBIDOS PARA TABELA
          self.tabela = tabelaSuccess

          // LIMPA O STATUS DA TABELA
          self.tabela.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if ([ '', null, undefined ].indexOf(callback) === -1) {
            callback()
          }
        }, self.produtoEtiquetaSetarStatusGeral)
      },
      produtoEtiquetaFinalizarCarregamento: function (self, callback) {
        // SETA O STAUS DA TELA
        self.produtoEtiquetaSetarStatusGeral('')

        // REALIZA O FOCUS NO CAMPO
        self.produtoEtiquetaOnFocusCampo(self.formulario.field.busca.id)

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if ([ '', null, undefined ].indexOf(callback) === -1) {
          callback()
        }
      },
      produtoEtiquetaOnKeyPressEnter: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        switch (index) {
          case 'busca':
            this.produtoEtiquetaOnFocusCampo(this.formulario.field.busca.id)
            break

          case 'qtde':
            this.produtoEtiquetaAdicionar()
            break
        }
      },
      produtoEtiquetaOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        switch (index) {
          case 'busca':
            if ([ '', null, undefined ].indexOf(value) === -1 && [ '', null, undefined ].indexOf(value.id) === -1) {
              // SETA O ID DO PRODUTO RECEBIDO
              this.formulario.field[index].valueRef = value.id
  
              // SETA O NOME DO PRODUTO RECEBIDO
              this.formulario.field[index].value = value.nome

              // SETA OS DADOS RECEBIDOS
              this.formulario.field[index].dados = value
  
              // REALIZA O FOCUS NO CAMPO
              this.produtoEtiquetaOnFocusCampo(this.formulario.field.qtde.id)
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
            break
        }
      },
      produtoEtiquetaAdicionar: function () {
        // SETA O STATUS DO BUTTON
        this.formulario.buttons.adicionar.status = 'carregando'
        this.formulario.buttons.limpar.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // INICIA O ID DA LINHA
        var indexL = ''

        // CRIA UMA CHAVE UNICA PARA O VETOR
        do {
          indexL = (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()
        } while (indexL === '' || this.tabela.ids.indexOf(indexL) !== -1)

        // ADICIONA O VALOR NO VETOR
        this.tabela.ids.push(indexL)

        // INICIA A LINHA
        var linha = this.formulario.field.busca.dados

        // SETA O ID DA LINHA
        linha.index = indexL

        // SETA A QUANTIDADE
        linha.qtde = this.formulario.field.qtde.value

        // FORMATA O VALOR 
        linha.valor_ven = 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linha.valor_ven)

        // ADICIONA A ETIQUETA DESEJADA
        this.tabela.linha.push(linha)
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA LIMPAR O CAMPO
        this.produtoEtiquetaLimpar([ 'busca', 'adicionar', 'limpar' ])

        // REALIZA O FOCUS NO CAMPO
        this.produtoEtiquetaOnFocusCampo(this.formulario.field.busca.id)
      },
      produtoEtiquetaOnFocusCampo: function (campo, tentativa = 0, self = null) {
        if (tentativa <= 10) {
          // SETA O VALOR PARA INICIAR A VARIAVEL
          if (self === null) {
            self = this
          }

          // VERIFICA SE O CAMPO E A FUNÇÃO DE FOCUS EXISTE
          if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && Object.keys(self.$refs[campo].$refs).length >= 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField) === -1) {
            self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField()
          } else {
            setTimeout(function () { self.produtoEtiquetaOnFocusCampo(campo, (tentativa + 1), self) }, 500)
          }
        }
      },
      produtoEtiquetaLimpar: function (limpar = [ 'busca', 'qtde' ]) {
        // CONVERTE EM ARRAY O VALOR RECEBIDO
        if (typeof limpar === 'string') {
          limpar = [ limpar ]
        }
        
        // REINICIA O CAMPO BUSCA
        if (limpar.indexOf('busca') !== -1) {
          this.formulario.field.busca.value = ''
          this.formulario.field.busca.valueRef = ''
          this.formulario.field.busca.valueRefStatus = ''
          this.formulario.field.busca.mensagem = ''
          this.formulario.field.busca.mensagemTipo = ''
        }

        // REINICIA O CAMPO QTDE
        if (limpar.indexOf('qtde') !== -1) {
          this.formulario.field.qtde.value = '1'
          this.formulario.field.qtde.mensagem = ''
          this.formulario.field.qtde.mensagemTipo = ''
        }

        // LIMPA O STATUS DO BOTÃO
        if (limpar.indexOf('adicionar') !== -1) {
          this.formulario.buttons.adicionar.status = ''
        }

        // LIMPA O STATUS DO BOTÃO
        if (limpar.indexOf('limpar') !== -1) {
          this.formulario.buttons.limpar.status = ''
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      produtoEtiquetaOnCheckboxAtualiza: function (coluna = null, checkbox = null) {
        if (coluna !== null && checkbox !== null) {
          // PEGA O ID DA COLUNA
          var indexColuna = this.tabela.coluna.findIndex(item => item.chave === coluna)

          // SETA O VALOR RECEBIDO NO CHECKBOX
          this.checkbox = checkbox.filter(item => item !== this.tabela.coluna[indexColuna].chave)
        }
      },
      produtoEtiquetaRemoverProduto: function () {
        // REMOVE OS IDS SOLICITADOS NO CHECKBOX
        this.tabela.linha = this.tabela.linha.filter(item => this.checkbox.indexOf(item.index) === -1)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      produtoEtiquetaBuscarQtdeEstoqueGerar: function () {
        if (this.config.fields.indexOf('pro_qtde_est') !== -1) {
          // INICIA O VETOR DE DADOS
          var ids = []

          // PEGA TODOS OS IDS DE PRODUTOS
          for (var indexL in this.tabela.linha) {
            ids.push(this.tabela.linha[indexL].id)
          }

          // REMOVER VALORES DUPLICADOS
          ids = ids.filter((v, i, a) => a.indexOf(v) === i)
          
          // FAZ A BUSCA DO ESTOQUE DOS IDS SOLICITADOS
          this.produtoEtiquetaBuscarQtdeTotalEstoque(ids)
        } else {
          this.produtoEtiquetaGerar()
        }
      },
      produtoEtiquetaBuscarQtdeTotalEstoque: function (ids, qtde = 350, ini = null, fim = null, registros = []) {
        // SETA OS DADOS QUE SERÁ BUSCADO
        if (ini === null && fim === null) {
          ini = 0
          fim = qtde
        } else if (ids.length > (ini + qtde)) {
          ini += qtde
          fim += qtde
        } else {
          ini = null
          fim = null
        }

        if (ini !== null && fim !== null) {
          // MONTA A PESQUINA NA API
          var queryGet = { ids: ids.slice(ini, fim) }

          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/produto/estoque/qtde/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VETORES
            registros = registros.concat(apiSuccess.lot)

            // BUSCA OS OSTROS REGISTROS FALTANTES
            this.produtoEtiquetaBuscarQtdeTotalEstoque(ids, qtde, ini, fim, registros)
          }, (apiError) => {
            this.statusGeral = apiError

            // ATUALIZA A DATA PARA FORÇAR REFRESH NA TABELA
            this.time = new Date().getTime()
          })
        } else {
          // PEGA TODOS OS IDS DE PRODUTOS
          for (var indexL in this.tabela.linha) {
            // INICIA A QUANTIDADE EM ESTOQUE DO PRODUTO
            this.tabela.linha[indexL].qtde_est = '---'

            // PROCURA O VALOR DO ESTOQUE DO PRODUTO
            var estoque = registros.filter(item => item.code === '200' && item.id === this.tabela.linha[indexL].id)

            // VERIFICA SE FOI ENCONTRADO ALGUM REGISTRO
            if (estoque.length >= 1) {
              // PEGA O VALOR ENCONTRADO
              estoque = estoque[0]

              // INICIA A QUANTIDADE EM ESTOQUE DO PRODUTO
              this.tabela.linha[indexL].qtde_est = estoque.data.estoque
            }
          }

          // CHAMA A FUNÇÃO PARA GERAR AS ETIQUETAS
          this.produtoEtiquetaGerar()
        }
      },
      produtoEtiquetaGerar: function () {
        if (this.buttonGerar.imprimir === false) {
          // INICIA AS VARIAVEIS
          var linha = 0
          var coluna = 0
          this.etiquetas = {}
  
          for (var key in this.tabela.linha) {
            for (var i = 1; i <= Number(this.tabela.linha[key].qtde); i++) {
              if (Object.keys(this.etiquetas).length >= 1 && Object.keys(this.etiquetas[linha]).length >= Number(this.config.cfg_n_colunas)) {
                // INICIA UMA NOVA LINHA
                linha++
                coluna = 0
              }
  
              // VERIFICA SE A LINHA JÁ FOI INICIADA
              if (!this.etiquetas.hasOwnProperty(linha)) {
                this.etiquetas[linha] = {}
              }
  
              // VERIFICA SE A COLUNA JÁ FOI INICIADA
              if (!this.etiquetas.hasOwnProperty(coluna)) {
                this.etiquetas[linha][coluna] = {}
              }
  
              // ADICIONA A ETIQUETA QUANTAS VEZES FOI SOLICITADO
              this.etiquetas[linha][coluna] = this.tabela.linha[key]
  
              // CALCULA O NUMERO DA COLUNA
              coluna++
            }
          }
        }

        setTimeout(() => {
          // VERIFICA SE DEVE MOSTRAR OU NÃO A CONFIGURAÇÃO
          this.buttonGerar.imprimir = !this.buttonGerar.imprimir

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }, (this.buttonGerar.imprimir === false ? 1000 : 0))
      },
      produtoEtiquetaAdicionarItens: function (callback = null) {
        if ([ '', null, undefined ].indexOf(this.cpntIds) === -1 && this.cpntIds.length >= 1) {
          // INICIA A VARIAVEL DE QUERYGET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVEM BUSCAR
          queryGet.field = { id: null, codigo: null, nome: null, id_cat: { j: { nome: null } }, id_mar: { j: { nome: null } }, valor_ven_novo: { a: 'valor_ven' }, cod_barra: null, status: null }

          // SETA OS IDS QUE DEVE BUSCAR
          queryGet.where = { aAnd: [
            { f: 'id', o: 'in', v: this.cpntIds.join() },
            { f: 'status', o: '=', v: '1' }
          ] }

          // FAZ A BUSCA DOS DADOS NA API
          this.$store.state.comunicaAPI('/produto/get', 'POST', queryGet, (apiSuccess) => {
            for (var index in apiSuccess.data) {
              // INICIA O ID DA LINHA
              var indexL = ''

              // CRIA UMA CHAVE UNICA PARA O VETOR
              do {
                indexL = (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString()
              } while (indexL === '' || this.tabela.ids.indexOf(indexL) !== -1)
  
              // ADICIONA O VALOR NO VETOR
              this.tabela.ids.push(indexL)
  
              // INICIA A LINHA
              var linha = apiSuccess.data[index]
  
              // SETA O ID DA LINHA
              linha.index = indexL
  
              // SETA A QUANTIDADE
              linha.qtde = this.formulario.field.qtde.value
  
              // FORMATA O VALOR 
              linha.valor_ven = 'R$ ' + this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', linha.valor_ven)
  
              // ADICIONA A ETIQUETA DESEJADA
              this.tabela.linha.push(linha)              
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
            if ([ '', null, undefined ].indexOf(callback) === -1) {
              callback()
            }
          }, this.produtoEtiquetaSetarStatusGeral)
        } else {
          // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
          if ([ '', null, undefined ].indexOf(callback) === -1) {
            callback()
          }
        }
      }
    }
  }
</script>
